import { BetStatus } from '@bg-shared/enums/BetStatus';
import { BettingOptionsFormat } from '@betgames/bg-tools';
import { GameId } from '@bg-shared/enums/GameId';
import { RedBlueColor } from '@bg-shared/enums/RedBlueColor';
import { ClassicGameDefinition } from '@bg-shared/utils/ClassicGameDefinition';

export const ROOT_CLASS = 'root';

export const STATIC_HEIGHT_CLASS = 'static-height';

export const CUSTOM_CSS_ID = 'custom-css';

export const POKER_HANDS_COUNT = 6;

export const TINY_WIDTH = 320; // px

export const DESKTOP_MIN_WIDTH = 768; // px

export const CONTAINER_WIDTH = 960; // px

export const SHOW_NOTIFICATION_TIME = 5000; // 5.0s

export const SHOW_REPEAT_BET_NOTIFICATION_TIME = 2000; // 2.0s

export const SHOW_RERUN_NOTIFICATION_TIME = 15000; // 15.0s

export const HOLD_BETSLIP_TIME = 1000; // 1.0s

export const BALANCE_REFRESH_INTERVAL = 30000; // 30.0s

export const PLAYER_INACTIVITY_TIME = 600000; // 10.0m

export const MAX_COMBO_ODDS_COUNT = 2;

export const MIN_CUSTOM_AMOUNT_BUTTONS_COUNT = 4;

export const MAX_CUSTOM_AMOUNT_BUTTONS_COUNT = 6;

export const MAX_LAST_RESULT: Record<number, number> = {
    [GameId.DICE_DUEL]: 5,
    [GameId.LUCKY5]: 5,
    [GameId.LUCKY6]: 5,
    [GameId.LUCKY7]: 5,
    [GameId.BETWAY_LUCKY7]: 5,
    [GameId.RNG_LUCKY7]: 5,
    [GameId.WHEEL]: 20,
    [GameId.RNG_WHEEL]: 5,
    [GameId.RNG_FOOTBALL_GRID]: 5,
    [GameId.RNG_ROULETTE]: 500,
    [GameId.SHOVA52]: 500,
    [GameId.LUCKY_KICKS]: 100,
    [GameId.STARZLE]: 500,
    ...ClassicGameDefinition.ROULETTE_GAMES_IDS.reduce(
        (result, id) => ({
            ...result,
            [id]: 500,
        }),
        {},
    ),
    ...ClassicGameDefinition.SKYWARD_GAMES_IDS.reduce(
        (result, id) => ({
            ...result,
            [id]: 30,
        }),
        {},
    ),
    [GameId.SKYWARD_DELUXE]: 100,
};

export const MAX_RECENT_BETS = 20;

export const MAX_VISIBLE_RECENT_BETS = 5;

export const TIMER_BLINK_START = 5;

export const NOTIFICATION_SHORT_TIMEOUT = 2000;
export const NOTIFICATION_LONG_TIMEOUT = 4000;
export const NOTIFICATION_ERROR_SHOW_TIME = 3000;

export const MESSAGE_ANIMATION_DURATION = 300;

// Decided by business
export const HOLD_DRAW_UPDATE_TIME = new Proxy<Partial<Record<GameId, number>>>(
    {
        [GameId.POKER]: 10000, // ms,
        [GameId.STS_POKER]: 10000, // ms,
        [GameId.BACCARAT]: 5000, // ms,
        [GameId.WAR]: 5000, // ms,
        [GameId.SIX_PLUS_POKER]: 5000, // ms,
        [GameId.RNG_FOOTBALL_GRID]: 1000, // ms
        [GameId.RNG_ROULETTE]: 4000, // ms
        [GameId.ROULETTE_EURO_LT]: 3000, // ms
        [GameId.ROULETTE_EURO_GE]: 3000, // ms
        [GameId.ROULETTE_AMERICAN_GE]: 3000, // ms
        [GameId.ROULETTE_FLASH_LT]: 3000, // ms
        [GameId.SHOVA52]: 3000, // ms
        [GameId.LUCKY_KICKS]: 2000, // ms
    },
    {
        get: (target, key: unknown) => target[key as GameId] ?? 0,
    },
);

export const HOLD_LOTTERY_RESULTS_TIME = 5000; // 5.0s

export const MAX_ITEMS: Record<number, number> = {
    [GameId.SIX_PLUS_POKER]: 9,
};

export const HOLD_CANCELLED_DRAW_MESSAGE_TIME = 20000; // 20.0s

export const FAVORITE_TAB_ID = -1;

export const MAIN_TAB_ID = 91;

export const BET_CLASSES_BY_STATUS = new Proxy<Partial<Record<BetStatus, string>>>(
    {
        [BetStatus.ACTIVE]: 'active',
        [BetStatus.WON]: 'won',
        [BetStatus.LOST]: 'lost',
        [BetStatus.RETURNED]: 'returned',
        [BetStatus.PUSH]: 'push',
        [BetStatus.TIE]: 'push',
        [BetStatus.INVALID]: '',
    },
    {
        get: (target, key: unknown) => target[key as BetStatus] ?? '',
    },
);

export const SIX_PLUS_POKER_CARD_COUNTS = {
    PLAYER: 2,
    DEALER: 2,
    TABLE: 5,
};

export const DEFAULT_TIMEZONE = 0;

export const DEFAULT_LANGUAGE = 'en';

export const DEFAULT_PARTNER_TOKEN = '-';

export const DEFAULT_ODDS_FORMAT = BettingOptionsFormat.DECIMAL;

// TODO remove type once it has some values
export const VEDIC_FORMAT_CURRENCIES: string[] = [
    // TODO: Uncomment once all places in iFrame will format currency using formatToCurrency method
    // 'inr'
];

export const CARD_SHORT_VALUE_10 = 't';

// TODO Remove Timeouts after BE implementation for quick betting
export const REQUEST_TIMEOUT_OFFSET = 1000;

export const MAX_PICK_X_LINES_PER_BET = 5;

export const RED_BLUE_COLORS_ORDER = [RedBlueColor.RED, RedBlueColor.BLUE];

export const INPUT_AMOUNT_SEQUENCE = [
    0.1, 0.2, 0.5, 1, 2, 5, 10, 20, 50, 100, 200, 500, 1000, 2000, 5000, 10000,
];

export const GAME_STOP_BETTING_OFFSET = 2; // s

export const DEFAULT_ROULETTE_NEIGHBOR_COUNT = 2;

export const TOOLTIP_DURATION = 3000; // ms

export const VIDEO_ASPECT_RATIO = 16 / 9;

export const DEFAULT_BETTING_TIMEOUT = 30000; // ms

export const BGI_BETTING_TIMEOUT = 10000; // ms

export const LUCKY_KICKS_ITEMS_COUNT = 3;

export const CHAT_LOGOUT_THRESHOLD = 5 * 60 * 1000; // 5 min

export const CHAT_MESSAGE_MAX_LENGTH = 300;

export const CHAT_ADMIN_ALIAS = 'Admin';

export const STARZLE_MAX_MULTIPLIER_MAIN = 1000;

export const STARZLE_PICK6_ITEMS_MAX = 6;

export const STARZLE_MAX_BALLS_COUNT = 48;
